import { FilterDivider } from '../../FilterDivider'
import { PageActions } from '../../Page'
import { Pagination } from '../../Pagination'
import {
  getTableResetSortingButton,
  Table,
  TableControlBar,
  TableControlButtons,
} from '../../Table'
import { getCategoryTableRowKey } from '../Category.utils'
import { CategoryTableRow } from '../CategoryTableRow'

import * as styles from './CategoryTableLayout.module.css'

function CategoryTableLayout({ emptyState = null, hasTable, tablePage }) {
  const {
    columns,
    handleApply,
    handleResetOrdering,
    handleSetColumns,
    handleSetOrdering,
    handleSetPagination,
    handleSetSize,
    isLoading,
    items,
    ordering,
    pageScrollWrapperRef,
    pagination,
    refreshButtonProps,
  } = tablePage

  return hasTable ? (
    <>
      <TableControlBar>
        <PageActions className={styles.pageActions} isLoading={isLoading}>
          <TableControlButtons
            ConfigButton={null}
            DensityButton={null}
            ResetSortingButton={getTableResetSortingButton(ordering)}
            refreshButtonProps={refreshButtonProps}
            resetSortingProps={{ onClick: handleResetOrdering }}
          />
          <FilterDivider />
          <Pagination
            responsive
            value={pagination}
            onChange={handleSetPagination}
            onChangeSize={handleSetSize}
          />
        </PageActions>
      </TableControlBar>
      <Table
        TableRow={CategoryTableRow}
        actionsColumnWidth={0}
        columns={columns}
        containerRef={pageScrollWrapperRef}
        getRowKey={getCategoryTableRowKey}
        headerRowProps={{
          ordering,
          onApply: handleApply,
          onSetColumns: handleSetColumns,
          onSetOrdering: handleSetOrdering,
        }}
        isLoading={isLoading}
        items={items?.items}
      />
    </>
  ) : (
    emptyState
  )
}

export default CategoryTableLayout
